import { yupResolver } from "@hookform/resolvers/yup";
import { isValidPhoneNumber } from "@root/utils/phoneLib";
import { placeSchema } from "@root/utils/resolvers/place";
import { type InferType, object, string } from "yup";

const formSchema = object().shape(
  {
    firstName: string(),
    lastName: string(),
    job: string(),
    email: string()
      .email("L'email n'est pas bien formaté")
      .when("phone", {
        is: "",
        // biome-ignore lint/suspicious/noThenProperty: <explanation>
        then: (schema) => schema.required("Ce champ est requis"),
      }),
    phone: string()
      .test("valid-phone", "Le format du numéro n'est pas valide", (val) => !val || isValidPhoneNumber(val))
      .when("email", {
        is: "",
        // biome-ignore lint/suspicious/noThenProperty: <explanation>
        then: (schema) => schema.required("Ce champ est requis"),
      }),
    place: placeSchema.required("Ce champ est requis"),
    description: string(),
  },
  [["email", "phone"]]
);

export const modalEditContactResolver = yupResolver(formSchema);
export type TModalEditContactForm = InferType<typeof formSchema>;
